function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#caeef4;}.b{fill:#1fc6cd;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3 -6.018)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M26.177,34.291l-5.565-7.155a.4.4,0,0,0-.314-.153H9.963a.4.4,0,0,0-.314.153L4.084,34.291A.4.4,0,0,0,4,34.535v3.18A2.387,2.387,0,0,0,6.385,40.1h17.49a2.387,2.387,0,0,0,2.385-2.385v-3.18A.4.4,0,0,0,26.177,34.291ZM15.13,36.522a3.18,3.18,0,1,1,3.18-3.18A3.18,3.18,0,0,1,15.13,36.522Z",
  transform: "translate(-0.603 -12.631)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M10.928,9.91,10.672,7.6a15.349,15.349,0,0,1,7.712,0L18.126,9.91a1.235,1.235,0,0,0,.787,1.289l3.811,1.467a1.235,1.235,0,0,0,1.511-.528l1.65-2.808a1.242,1.242,0,0,0-.322-1.619,18.334,18.334,0,0,0-22.07,0A1.243,1.243,0,0,0,3.17,9.33l1.652,2.81a1.236,1.236,0,0,0,1.511.527L10.142,11.2a1.237,1.237,0,0,0,.785-1.289Z",
  transform: "translate(0 2)"
}));

var SvgTelephone = function SvgTelephone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.056,
    height: 21.451,
    viewBox: "0 0 23.056 21.451",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTelephone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/telephone.16f05c04.svg";
export { ForwardRef as ReactComponent };